<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

// import logoWhite from '@/assets/aurocraft-logo.svg'
// import logoBlack from '@/assets/aurocraft-logo-dark.svg'
// import logoBlack from '@/assets/aurocraft-logo-orange.svg'

export default {

  name: 'Logo',

  props: {
    mode: {
      type: String,
      default: 'white',
      validator (value) {
        return value.match(/^white|black$/)
      }
    }
  },

  computed: {
    logo () {
      return this.mode === 'white' ? logoWhite : logoBlack
    },

    lang () {
      return this.$route.params.lang
        ? this.$route.params.lang
        : ''
    },
    isMobile(){
      return this.$store.getters.isMobile
    },

    menuOpenMobile(){
      return (this.$store.getters.isPopupOpened && this.isMobile)
    }

  },

  methods: {
    onLinkClick () {
      if (this.$store.getters.isPopupOpened) {
        this.$store.dispatch('closePopup', true)
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.logo-container(v-if="!menuOpenMobile")
  router-link(@click.native="onLinkClick", :to="'/' + lang", :class="['is-' + mode]").logo-link
    svg.logo(width="154px" height="16px" viewBox="0 0 154 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink")
      defs
        polygon#path-1(points="14.9082191 0.1115 0.768527941 0.1115 0.768527941 15.8751125 14.9082191 15.8751125 14.9082191 0.1115")
        polygon#path-3(points="16.4484456 15.875 0 15.875 0 0.1115 16.4484456 0.1115 16.4484456 15.875")
        polygon#path-5(points="14.2674206 0.1115 0.554626471 0.1115 0.554626471 15.8751125 14.2674206 15.8751125 14.2674206 0.1115")
        polygon#path-7(points="11.7803206 0.1115 0.323173529 0.1115 0.323173529 15.829325 11.7803206 15.829325 11.7803206 0.1115")
        polygon#path-9(points="12.6800882 15.6205125 12.6800882 0.0043875 0.813595588 0.0043875 0.813595588 15.6205125 12.6800882 15.6205125")
        polygon#path-11(points="13.7349882 0.1115 0.0210617647 0.1115 0.0210617647 15.8751125 13.7349882 15.8751125 13.7349882 0.1115")
        polygon#path-13(points="0.961254412 15.875 17.4086809 15.875 17.4086809 0.1115 0.961254412 0.1115")
      g(stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(-65.000000, -71.000000)')
        g#Page-1-Copy(transform='translate(65.000000, 71.000000)')
          g#Group-3(transform='translate(18.117647, 0.013950)')
            path.letter#Fill-1(d='M7.38260147,15.875225 L8.29527794,15.875225 C11.9799544,15.6401 14.9082191,12.594725 14.9082191,8.87435 L14.9082191,0.1106 L10.8894985,0.1106 L10.8894985,8.87435 C10.8894985,10.5461 9.52048382,11.906225 7.83893971,11.906225 C6.15626324,11.906225 4.78724853,10.5461 4.78724853,8.87435 L4.78724853,0.1106 L0.768527941,0.1106 L0.768527941,8.87435 C0.768527941,12.594725 3.69679265,15.6401 7.38260147,15.875225' mask='url(#mask-2)')
          g#Group-6(transform='translate(0.000000, 0.013950)')
            path.letter#Fill-4(d='M7.93881324,5.2173125 L9.40634265,8.9466875 C8.43365147,9.0164375 7.46775441,9.1581875 6.50978382,9.3449375 L7.93881324,5.2173125 Z M4.24960735,15.8755625 L4.95053382,13.8494375 C6.90044559,13.2183125 8.91829853,12.8943125 10.9542691,12.8785625 L12.1341809,15.8755625 L16.4484456,15.8755625 L10.2431515,0.1109375 L5.45669559,0.1109375 L-0.000113235294,15.8755625 L4.24960735,15.8755625 Z' mask='url(#mask-4)')
          g#Group-9(transform='translate(89.455882, 0.013950)')
            path.letter#Fill-7(d='M4.57221471,4.107725 L7.89227353,4.107725 C8.89100882,4.107725 9.70517059,4.915475 9.70517059,5.907725 C9.70517059,6.899975 8.89100882,7.707725 7.89227353,7.707725 L4.57221471,7.707725 L4.57221471,4.107725 Z M4.57221471,15.74585 L4.57221471,11.70035 L7.76658235,11.70035 L9.80368529,15.875225 L14.2674206,15.875225 L11.5882735,10.382975 C12.8904794,9.31985 13.7227588,7.70885 13.7227588,5.907725 C13.7227588,2.71385 11.1070235,0.1151 7.89227353,0.1151 L4.57221471,0.1151 L4.57221471,0.1106 L0.554626471,0.1106 L0.554626471,15.74585 L4.57221471,15.74585 Z' mask='url(#mask-6)')
          path.letter#Fill-10(d='M61.9710721,11.919725 C59.811675,11.919725 58.0531309,10.173725 58.0531309,8.027225 C58.0531309,5.88185 59.811675,4.134725 61.9710721,4.134725 C64.1304691,4.134725 65.8878809,5.88185 65.8878809,8.027225 C65.8878809,10.173725 64.1304691,11.919725 61.9710721,11.919725 M69.9066015,8.027225 C69.9066015,3.680225 66.3464838,0.143225 61.9710721,0.143225 C57.5956603,0.143225 54.0355426,3.680225 54.0355426,8.027225 C54.0355426,12.22235 57.3522044,15.65135 61.5147338,15.888725 L62.4274103,15.888725 C66.5899397,15.65135 69.9066015,12.22235 69.9066015,8.027225' )
          path.letter#Fill-12(d='M86.6954324,12.578975 L83.4172706,10.26935 C82.6801088,11.303225 81.4843441,11.919725 80.2195059,11.919725 C78.0601088,11.919725 76.3026971,10.173725 76.3026971,8.027225 C76.3026971,5.88185 78.0601088,4.134725 80.2195059,4.134725 C81.4843441,4.134725 82.6801088,4.75235 83.4172706,5.7851 L86.6954324,3.477725 C85.2063882,1.389725 82.7854176,0.143225 80.2195059,0.143225 C75.8440941,0.143225 72.2839765,3.680225 72.2839765,8.027225 C72.2839765,12.22235 75.6006382,15.65135 79.7631676,15.888725 L80.5999765,15.888725 C83.0220794,15.771725 85.2799912,14.56235 86.6954324,12.578975')
          g#Group-16(transform='translate(125.691176, 0.013950)')
            polygon.letter#Fill-14(mask='url(#mask-8)' points='0.323173529 0.1109375 0.323173529 15.8294375 4.34076176 15.8294375 4.34076176 10.9131875 10.2233353 10.9131875 10.2233353 6.9216875 4.34076176 6.9216875 4.34076176 4.1204375 11.7803206 4.1204375 11.7803206 0.1109375')
          g#Group-19(transform='translate(140.411765, 0.138950)')
            polygon.letter#Fill-17(mask='url(#mask-10)' points='0.813595588 3.9958875 4.73833088 3.9958875 4.73833088 15.6205125 8.75591912 15.6205125 8.75591912 3.9958875 12.6806544 3.9958875 12.6806544 0.0043875 0.813595588 0.0043875')
          g#Group-22(transform='translate(37.367647, 0.013950)')
            path.letter#Fill-20(d='M4.03865,4.107725 L7.35984118,4.107725 C8.35857647,4.107725 9.17160588,4.915475 9.17160588,5.907725 C9.17160588,6.899975 8.35857647,7.707725 7.35984118,7.707725 L4.03865,7.707725 L4.03865,4.107725 Z M4.03865,15.74585 L4.03865,11.70035 L7.23301765,11.70035 L9.27012059,15.875225 L13.7349882,15.875225 L11.0558412,10.382975 C12.3580471,9.320975 13.1903265,7.70885 13.1903265,5.907725 C13.1903265,2.71385 10.5745912,0.1151 7.35984118,0.1151 L4.03865,0.1151 L4.03865,0.1106 L0.0210617647,0.1106 L0.0210617647,15.74585 L4.03865,15.74585 Z' mask='url(#mask-12)')
          g#Group-25(transform='translate(105.308824, 0.013950)')
            path.letter#Fill-23(d='M7.47115147,9.3449375 L8.90018088,5.2184375 L10.3677103,8.9466875 C9.39388676,9.0164375 8.42912206,9.1581875 7.47115147,9.3449375 L7.47115147,9.3449375 Z M6.41806324,0.1109375 L0.961254412,15.8755625 L5.210975,15.8755625 L5.91303382,13.8494375 C7.86068088,13.2183125 9.87966618,12.8943125 11.9145044,12.8785625 L13.0944162,15.8755625 L17.4086809,15.8755625 L11.2033868,0.1109375 L6.41806324,0.1109375 Z' mask='url(#mask-14)')




</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.logo-container
  display flex

.logo-link
  position relative
  display flex
  justify-content center
  align-items center
  // padding 21px
  width 200px
  height 58px

  &:after
    content 'Beta'
    position absolute
    top 12px
    right 24px
    font-size 8px
    font-weight 500
    color orange
    text-transform uppercase
    letter-spacing 0.1

    .is-white&
      color white

.logo .letter
  transition fill .3s

.is-white & .logo .letter
  fill white

.is-black & .logo .letter
  fill primary

.logo:hover .letter
  fill orange

// ===========================================
// Animations
// ===========================================

.logo-enter
.logo-leave-to
  opacity 0
  visibility hidden

.logo-enter-active
  position absolute
  top 0
  right 0
  bottom 0
  left 0
  margin auto

.logo-enter-active
.logo-leave-active
  transition opacity .5s, visibility .5s

</style>



// WEBPACK FOOTER //
// logo.vue?da672014